export default "__VITE_ASSET__DIJr0UhD__"